import React from 'react';
import ReactDOM from 'react-dom';
//CSS
import './style/index.css';
import Router from "./components/Router"

ReactDOM.render(
  <Router />,
  document.getElementById('root')
);

